import React, { useEffect, useMemo } from "react";

import Button from "../../button/Button";
import useThemService, { MUIComponentsTheme } from "../../../services/theme-service/ThemeService";
import { CompareArrows, SvgIconComponent } from "@mui/icons-material";
import { PubSubEvents } from "../../../services/PubSubEvents";
import dateService from "../../../services/date-service/DateService";
import { translationService } from "../../../services/translation/TranslationService";
import { CircularProgress, ThemeProvider } from "@mui/material";

interface CompareButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  onCompareFinished: (notification: Notification) => void;
  lastCompared: Date;
}

export default function CompareButton(props: CompareButtonProps) {
  const { themeClass } = useThemService();

  const svg = useMemo(() => {
    return props.disabled ? 
      () => {return (<></>)} : CompareArrows;
  }, [props.disabled]);

  useEffect(() => {
    var compareSubscribeToken = PubSub.subscribe(
      PubSubEvents.ComparisonUpdated,
      async (_event: string, notification: Notification) => {
        props.onCompareFinished(notification);
      }
    );

    return function cleanup() {
      PubSub.unsubscribe(compareSubscribeToken);
    };
  }, []);

  return (
    <>
      {props.disabled && 
        <ThemeProvider theme={MUIComponentsTheme}>
          <CircularProgress />
        </ThemeProvider>
      }
      <Button
        icon={{
          svg: svg,
          textKey: "general.inspection.compare",
          className: themeClass(["icon-compare"]),
        }}
        onClick={props.onClick}
        disabled={props.disabled}
      />
      <div className="header-subscribed">
        {translationService.translate("ProjectInspections.project.lastCompared", {
            lastCompared: dateService.formatDate(props.lastCompared, "P p"),
        })}
      </div>
    </>
  );
}
